<div class="modal fade admin-modal seat-limit-reached" bsModal="bsModal" tabindex="-1" role="dialog" aria-hidden="true" #seatLimitReachedModal="bs-modal">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <button class="btn-close-modal" (click)="cancel()" type="button" i18n-aria-label="Close" aria-label="Close"><span class="close-modal-x" aria-hidden="true">&times;</span></button>
      <div class="modal-header text-center">
        <h2 class="modal-title text-center" i18n="Seat limit reached title@@seatLimitReachedTitle">User limit reached</h2>
      </div>
      <div class="modal-body text-justify">
        <p i18n="Seat limit reached body@@seatLimitReachedBody">
          Your EndNote Fusion user limit has been reached. You can disable unused accounts to free up seats.
        </p>
        <p i18n="Seat limit reached body 2@@seatLimitReachedBody2">
          To permanently remove users contact <a href="https://supportcenter.clarivate.com/s/product-or-technical-question?language=en_US&lPage=EndNote" target="_blank" rel="noopener">Tech Support</a>. For more options please contact your Clarivate account manager or <a href="mailto:endnote.sales&#64;clarivate.com">endnote.sales&#64;clarivate.com</a>.
        </p>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary" (click)="cancel()" type="button" i18n="Seat limit reached close button@@seatLimitReachedClose">Close</button>
      </div>
    </div>
  </div>
</div>
